import { Controller } from "@hotwired/stimulus"

// Reloads the closest Turbo Frame on a fixed interval until disconnected.
// Usage:
//   <turbo-frame data-controller="turbo-poll"
//                data-turbo-poll-interval-value="4000"
//                data-turbo-poll-src-value="/path/to/refresh">
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 4000 },
    src: String
  }

  connect() {
    this.timer = setInterval(() => this.reload(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  reload() {
    const frame = this.element.closest("turbo-frame") || this.element
    if (!frame || frame.tagName.toLowerCase() !== "turbo-frame") return

    if (this.hasSrcValue && this.srcValue.length > 0) {
      frame.setAttribute("src", `${this.srcValue}${this.srcValue.includes("?") ? "&" : "?"}_=${Date.now()}`)
    } else {
      frame.reload()
    }
  }
}
